<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure
              itaque ducimus dolores id quod labore sapiente earum est sed
              velit, fugiat eligendi neque molestias veniam ad eveniet
              perferendis tempora ab!
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt-3">
      <form-wizard color="#fc7c47">
        <template slot="title">
          <div class="col-12">
            <img
              class="mx-auto d-block img-fluid mb-3 img-title"
              src="/img/brand/logo_stars_black_min.png"
            />
            <h3 class="text-muted font-weight-normal">
              Programa de Pré-Aceleração
            </h3>
          </div>
        </template>
        <tab-content title="Fase 1: Inspiração" icon="fa fa-paper-plane">
          <div class="card card-profile shadow">
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <div class="d-flex justify-content-between">
                <base-button size="sm" type="warning" class="mr-4"
                  >Inspiração</base-button
                >
                <base-button size="sm" type="info" class="float-right"
                  >Fase 1</base-button
                >
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="mt-md-5">
                    <steps fase="steps1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Fase 2: Engajamento" icon="fa fa-plane-departure">
          <div class="card card-profile shadow">
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <div class="d-flex justify-content-between">
                <base-button size="sm" type="warning" class="mr-4"
                  >Pré-aceleração</base-button
                >
                <base-button size="sm" type="info" class="float-right"
                  >Fase 2</base-button
                >
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="mt-md-5">
                    <steps fase="steps2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Fase 3: Escala" icon="fa fa-plane">
          <div class="card card-profile shadow">
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <div class="d-flex justify-content-between">
                <base-button size="sm" type="warning" class="mr-4"
                  >Pré-aceleração</base-button
                >
                <base-button size="sm" type="info" class="float-right"
                  >Fase 3</base-button
                >
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="mt-md-5">
                    <steps fase="steps3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Bora pro Bootcamp!" icon="fa fa-map-marker-alt">
          <div class="card card-profile shadow">
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <div class="d-flex justify-content-between">
                <base-button size="sm" type="warning" class="mr-4"
                  >Pré-aceleração</base-button
                >
                <base-button size="sm" type="info" class="float-right"
                  >Bootcamp</base-button
                >
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="mt-md-5">
                    <steps fase="bootcamp" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Fase 4: Impacto" icon="fa fa-rocket">
          <div class="card card-profile shadow">
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <div class="d-flex justify-content-between">
                <base-button size="sm" type="warning" class="mr-4"
                  >Pré-aceleração</base-button
                >
                <base-button size="sm" type="info" class="float-right"
                  >Fase 4</base-button
                >
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="mt-md-5">
                    <steps fase="steps4" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Chegou o Demoday!" icon="fa fa-globe-americas">
          <div class="card card-profile shadow">
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <div class="d-flex justify-content-between">
                <base-button size="sm" type="warning" class="mr-4"
                  >Pré-aceleração</base-button
                >
                <base-button size="sm" type="info" class="float-right"
                  >Demoday</base-button
                >
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="mt-md-5">
                    <steps fase="demoday" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
              ><i class="fas fa-chevron-left mr-2"></i> Voltar</wizard-button
            >
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              >Avançar
              <i class="fas fa-chevron-right ml-2"></i>
            </wizard-button>
          </div>
        </template>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "pre-aceleracao",
  components: {
    FormWizard,
    TabContent,
    WizardButton,
  },
  methods: {
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.img-title {
  max-width: 400px;
}
</style>
